var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"button",class:_vm.classes,attrs:{"id":_vm.id,"type":_vm.type,"href":_vm.href,"to":_vm.to,"disabled":_vm.disabled},on:{"click":function($event){_vm.prevent ? _vm.setDefault($event) : '', _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }